export default {
    me: 'me',
    dashboard: 'dashboard',

    admins: 'admins',
    roles: 'roles',
    categories: 'categories',
    brands: 'brands',
    brandAmbasador: 'brand-ambasador',
    campaignTypes: 'campaign-types',
    campaign: 'campaign',
    campaignLinkRules: 'campaign-link-rules',
    products: 'products',
    appliesCampaign: 'campaign/applies-campaign',
    changeStatusCampaign: 'campaign/change-status',
    changeStatusSub: 'campaign/change-status-sub',
    changeStatusJobDraft: 'campaign-job/change-status-draft',
    changeStatusJobPublish: 'campaign-job/change-status-content',
    campaignJob: 'campaign-job',
    skinConcerns: 'skin-concerns',
    skinTypes: 'skin-types',
    tiers: 'tiers',
    banners: 'banners',
    bannersChangeOrder: 'banners/change-order',
    pages: 'pages',
    events: 'events',
    withdraws: 'withdraws',
    redeems: 'redeems',
    scheduler: 'scheduler',
    chatManagement: 'chat-managements',
    exportExcel: 'redeems/excel',
    exportBAExcel: 'brand-ambasador/excel',
    exportWithdrawExcel: 'withdraws/export',
    channels: 'channels',
    chat: 'chat',
    community: 'communities',
    notification: 'custom-notifications',
    leaderboard: 'leaderboard',

    // misc
    menus: 'misc/menus',
    misc_brands: 'misc/brands',
    misc_banners: 'misc/banners',
    misc_contentTypes: 'misc/content-types',
    misc_skinConcerns: 'misc/skin-concerns',
    misc_skinTypes: 'misc/skin-types',
    mics_tiers: 'misc/tiers',
    misc_campaignTypes: 'misc/campaign-types',
    misc_categories: 'misc/categories',
    misc_products: 'misc/products',
    misc_events: 'misc/events',
    misc_ambassadors: 'misc/brand-ambasadors?name=not:null',
    misc_channels_official: 'misc/channels/official',
    misc_channels_group: 'misc/channels/group',
    misc_campaign_platform: 'misc/campaign-platforms',
    misc_campaigns: 'misc/campaigns'
}
